export const SALESFORCE_VISITOR_LANGUAGES = {
  ENGLISH: 'English',
  FRENCH: 'French',
  SPANISH: 'Spanish',
};
